import { Component, OnInit, Inject, Output, EventEmitter, OnDestroy } from '@angular/core';
import { TrainDataService } from '../../../trains/services/train-data.service';
import { TripDataService } from '../../../trips/services/trip-data.service';
import { StateService } from '@uirouter/core';
import { Train } from '../../../trains/models/train';
import {ConfigurationDataService} from '../../../configurations/services/configuration-data.service';
import { ToastBehaviorSubjectService } from '../../../../shared/services/toast-behavior-subject.service';
import { MessageService } from 'primeng/api';
import {AnalysisInformationService} from '../../services/analysis-information.service';
import {DataImportExportService} from '../../../../shared/services/data-import-export.service';
import {Observable, Subscription} from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { ParseUrlDateStringToDatePipe } from '../../../../shared/pipes/parse-url-date-string-to-date.pipe';
import { ExportFilenameService } from '../../../../shared/services/export-filename.service';
import {ProjectConfiguration} from '../../../project/models/project-configuration';

const nocUtil = require('../../../../../../noc/util/noc-util');
const messageDiscriptors = require('../../../../../../noc/util/messageDiscriptors');
@Component({
  selector: 'app-analysis-information',
  template: require('./analysis-information.component.html'),
  styles: [require('./analysis-information.component.sass')]
})
export class AnalysisInformationComponent implements OnInit, OnDestroy {
  isTrip: boolean;
  selectedTrips: any[] = [];
  trainData: any;
  trains: Train[] | undefined;
  train: Train | undefined;

  previousTrip: any;
  nextTrip: any;

  urlParameters = JSON.parse(JSON.stringify(this.$state.params));
  selectedOfficialId: any;

  periodTzFrom: any;
  periodTzTo: any;

  updatePeriod: boolean = true;

  projectConfiguration: ProjectConfiguration;
  periodOverviewDateRange: number;

  activeConfig: any;

  selectedCsvMessageType: string;
  csvExports: {type: string; title: string}[] = [
    { type: "virtualusermessages", title: "Virtual user statistics"},
    { type: "trainusermessages", title: "User statistics"},
    { type: "gpsmessages", title: "GPS data statistics"},
    { type: "portalconsumption", title: "Portal consumption statistics"},
    { type: "linkstatistics", title: "Link statistics"}
 ];

  loading = false;

  trainTypeObjects: any[];
  maintainersObjects: any[];

  selectedMaintainer: string | undefined;
  selectedTrainType: string | undefined;

  from: Date | undefined; 
  to: Date | undefined; 

  @Output() reloadPeriod = new EventEmitter<any>();

  @Output() changeTrip = new EventEmitter<any>();

  projectId: number;
  trains$: Observable<Train[]>;
  trainTypes$: Observable<string[]>;
  maintainers$: Observable<string[]>;
  trainIds: (string | number | undefined)[];
  toastBehaviorSubjectSubscription: Subscription;

  constructor(
    public $state: StateService,
    @Inject('ProjectService') private projectService: any,
    @Inject('AuthenticationFactory') private authenticationFactory: any,
    @Inject('TimeZoneFactory') private timeZoneFactory: any,
    @Inject('TripOverviewFactory') private tripOverviewFactory: any,
    @Inject('SqiFactory') private sqiFactory: any,
    @Inject("TrainTypeService") private trainTypeService: any,
    @Inject("TrainMaintainerService") private trainMaintainerService: any,
    private trainDataService: TrainDataService,
    private tripDataService: TripDataService,
    private configurationDataService: ConfigurationDataService,
    private toastBehaviorSubjectService: ToastBehaviorSubjectService,
    private messageService: MessageService,
    private analysisInformationService: AnalysisInformationService,
    private dataImportExportService: DataImportExportService,
    private parseUrlDateStringToDatePipe: ParseUrlDateStringToDatePipe
  ) {

    this.toastBehaviorSubjectSubscription = this.toastBehaviorSubjectService.changeOccured.subscribe((message) => {
      this.messageService.add(message);
    })
  }

  async ngOnInit()  {
    this.projectId = this.$state.params && this.$state.params.projectId;
    const relativeId = this.$state.params && this.$state.params.trainId;
    this.from = this.$state.params && this.$state.params.startDate  && this.parseUrlDateStringToDatePipe.transform(this.$state.params.startDate);
    this.to = this.$state.params && this.$state.params.endDate  && this.parseUrlDateStringToDatePipe.transform(this.$state.params.endDate);
    this.trains$ = this.trainDataService.getTrainslist(this.projectId).pipe(
      tap((trains) => {
        this.trainIds = trains.filter(train => train.relativeId === parseInt(relativeId)).map(train => train.id)
      })
    );
    this.trainTypes$ = this.trains$.pipe(map(trains => {
      return [...new Set(trains.map(train => {
          return train.displayTypeName || train.trainType;
      }))]

    }));
    this.maintainers$ = this.trains$.pipe(map(trains => [...new Set(trains.map(train => train.maintainer))]));

    let data;
    const utcStart = this.$state.params ? this.timeZoneFactory.formatWithTimeZone(this.$state.params.startDate) : null;
    const utcEnd = this.$state.params ? this.timeZoneFactory.formatWithTimeZone(this.$state.params.endDate) : null;
    this.activeConfig = await this.configurationDataService.getProjectConfigurations(this.$state.params.projectId).toPromise();
    this.projectConfiguration = this.activeConfig && this.activeConfig[0];
    this.periodOverviewDateRange = this.projectConfiguration && this.projectConfiguration.periodRange && this.projectConfiguration.periodRange.periodOverviewRange;
    if (this.$state.current && this.$state.current.name) {
        if (this.$state.current.name.includes('period-analysis')) {
            this.updatePeriod = false;
            this.isTrip = false;
            try {
              data = await this.trainDataService.getPeriodData(utcStart, utcEnd, this.$state.params.projectId, this.$state.params.trainId);
            } catch (error) {
              this.$state.go('period.search', {
                projectId: this.$state.params.projectId
              })
            }
        }
        if (this.$state.current.name.includes('trip-analysis')) {
          this.updatePeriod = false;
            this.isTrip = true;
            try {
              data = await this.tripDataService.getTripById(this.$state.params.tripId, this.$state.params.projectId);
            } catch (error) {
              this.$state.go('trip.search', {
                projectId: this.$state.params.projectId
              })
            }
        }
        await this.processData(data);

        this.loading = false;
    }
  }

  processData = async (data: any) => {
      if (data) {
        this.trainData = {
          name: data.trainName,
          relativeTrainId: data.trainId,
          from: data.departure,
          to: data.arrival,
          projectId: data.projectId,
          projectName: data.projectName,
          isTrip: this.isTrip,
          tripId: data.id,
          trajectory: data.trajectory,
          statistics: data.statistics,
          officialId: data.officialId
      };
      } else {
        this.trainData = {
          projectId: this.$state.params.projectId,
          isTrip: false,
          from: new Date(),
          to: new Date()
        }
        this.trainData.from.setHours(0,0, 0);
      }

      // make sure we got real dates in From and to.
      this.trainData.tzFrom = nocUtil.toDate(this.trainData.from);
      this.trainData.tzTo = nocUtil.toDate(this.trainData.to);

      const offset = this.timeZoneFactory.getOffset();

      if (0 < offset) {
          this.trainData.tzFrom = new Date(this.trainData.tzFrom.getTime() - offset);
          this.trainData.tzTo = new Date(this.trainData.tzTo.getTime() - offset);
      } else {
          this.trainData.tzFrom = new Date(this.trainData.tzFrom.getTime() + offset);
          this.trainData.tzTo = new Date(this.trainData.tzTo.getTime() + offset);
      }

      this.periodTzFrom = this.trainData.tzFrom;
      this.periodTzTo = this.trainData.tzTo;

      if (!this.trainData.isTrip) {
          const trains = await this.trainDataService.getTrainslist(this.trainData.projectId).toPromise();
          if (trains) {
            this.train = trains.find(train => train.relativeId === this.trainData.relativeTrainId);
            this.selectedOfficialId = this.train && this.train.officialId;
            this.trains = trains.sort((t1: Train, t2: Train) => t1.name > t2.name ? 1 : -1 );
            this.trainTypeObjects = this.trainTypeService.getTrainTypeObjects(this.trains);
            this.maintainersObjects = this.trainMaintainerService.getTrainMaintainerObjects(this.trains);
            const selectedTrain = this.trains.find(train => train.relativeId === this.trainData.relativeTrainId);
            this.selectedMaintainer = selectedTrain && selectedTrain.maintainer;
            this.selectedTrainType = selectedTrain && selectedTrain.trainType;
          }
          

      } else {
          this.previousTrip = this.tripOverviewFactory.getPreviousId(this.trainData.tripId);
          this.nextTrip = this.tripOverviewFactory.getNextId(this.trainData.tripId);
      }
      const tmpMap = this.tripOverviewFactory.getInformationMap();

      this.selectedTrips = [];
      tmpMap.forEach((value, key) => {
          this.selectedTrips.push({
              value,
              key
          });
      });

      const statistics = await this.sqiFactory.createProjectSpecficSqis(
          this.trainData.statistics,
          -999,
          this.projectService.getSelectedProjectId()
          );

      this.trainData.specificStatistics = statistics.filter(stat => !!stat).length > 0 ? statistics : null;
  }

  onReloadPeriod = (data: {
    trains: Train[],
    from: number,
    to: number,
    hideSchedulingErrors: boolean
  }) => {
      const selectedTrain = data.trains[0]
      if (selectedTrain) {
        this.reloadPeriod.emit( {
          ...this.urlParameters,
          trainId: selectedTrain.relativeId, // add the new trainId to the parameters object
          startDate: data.from,
          endDate: data.to
        });
      }

      this.loading = true;
  }

  onChangeTrip = (selectedTripId) => {
    this.changeTrip.emit({
      ...this.urlParameters,
      tripId: selectedTripId
    });

  }

  getSlaMetadataByTitle = (title) => {
    return this.sqiFactory.getSlaByProperty('title', title, this.projectService.getSelectedProjectId());
  }

  createExportUrl = async () => {
    if (this.selectedCsvMessageType) {
        const selectedMessage = this.csvExports.find(message => message.type === this.selectedCsvMessageType);
        const statisticName = selectedMessage?.title.replace(/(^\w{1})|(\s+\w{1})/g, letter => letter.toUpperCase()).replace(" ","-")
        const period = this.timeZoneFactory.formatUtcToBackendPeriod(this.trainData.from, this.trainData.to);
        const object = {
            trainId: this.trainData.relativeTrainId,
            projectId: this.trainData.projectId,
            from: period.start,
            to: period.end,
            token: this.authenticationFactory.getUser() && this.authenticationFactory.getUser().token
        };
        const url = nocUtil.createCsvUrlPeriod(this.selectedCsvMessageType, object);
        const data = await this.analysisInformationService.getCSVMessages(url.replace(/[+]/g, '%2B')).toPromise();
        let exportName = ExportFilenameService.generate(this.trainData.isTrip ? "Trip-Analysis" : "Period-Analysis", statisticName, undefined, this.trainData.isTrip ? this.trainData.tripId : this.trainData.name, this.from, this.to);
        this.dataImportExportService.exportCSV(data.messages, this.createExportColumns(data.fieldNames), exportName, data.separator);
    }
    }

    public createExportColumns(map: any) {
        let columns: [string, string][] = [];
        columns = Object.entries(map);
        return columns;
    }

   ngOnDestroy(): void {
    console.log("ngOnDestroy")
    this.toastBehaviorSubjectSubscription && this.toastBehaviorSubjectSubscription.unsubscribe();
   }
    
}
